import { render, staticRenderFns } from "./homePartDoctors.vue?vue&type=template&id=4bb3a992&scoped=true&"
import script from "./homePartDoctors.vue?vue&type=script&lang=js&"
export * from "./homePartDoctors.vue?vue&type=script&lang=js&"
import style0 from "./homePartDoctors.vue?vue&type=style&index=0&id=4bb3a992&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb3a992",
  null
  
)

export default component.exports